import { AddPaymentPage } from "@/pages/PracticeWriteCheck";
export default AddPaymentPage;
